// extracted by mini-css-extract-plugin
module.exports = {"label":"news-card_label__2ZWN1","date":"news-card_date__2Y8NO"};